import { Icon } from "@blueprintjs/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";


export default function NotFound() {

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="app-container">
            <div className="app-overlay">
                <div className="row m-0 p-o">
                    <div className="container">
                        <div className="row justify-content-center m-5">
                            <div className="col-md-6 col-sm-12">

                                <div className="text-center mb-4"><Icon icon={'issue'} size={96} color="#5e4239" /></div>
                                <h1 className="text-center">{t("notFound.title")}</h1>
                                <p>{t("notFound.p")}</p>
                                <p className="text-center"><a href="#" onClick={() => navigate("/login")} > { t("notFound.link") }</a></p>

                        </div>
                    </div>
                </div>

            </div>
        </div>
        </div >

    );
}
